import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { CustomButton, DateTimePicker, Loading } from '../../../_common';
import { Col, Dropdown, Row, Table } from 'react-bootstrap';
import '../JobLogs.scss';
import '../../../_common/SearchableDropdown/SearchableDropdown.scss';
import {
    GetJobLogs_getJobLogs_details as JobLogDetailsType,
    GetJobLogMetaData_getJobLogMetaData_types as JobLogTypesType,
    GetJobLogMetaData_getJobLogMetaData_issues as JobLogIssueType,
    GetStagesForJobLog_getStagesForJobLog as StagesForAddType,
    GetJobLogMetaData_getJobLogMetaData_rootcauses as JobLogRootCauseType,
    GetJobLogMetaData_getJobLogMetaData_locationLOFAs as JobLogLocationLofaType,
    GetJobLogNotes_getJobLogNotes as JobLogNotesType,
    GetStages,
    GetStagesForJobLog,
    GetJobLogNotes,
} from '../../../../types/schemaTypes';
import { blockInvalidChar } from '../../../_common/blockInvalidChar';
import { useQuery } from '@apollo/client/react';
import { GET_JOBLOG_NOTES, GET_STAGES, GET_STAGES_FOR_JOBLOG } from '../../../../graphql/client/queries';

interface AddEditJobLogModalProps {
    jobId: number;
    jobLogsData: JobLogDetailsType | undefined;
    jobLogsTypesData: JobLogTypesType[];
    jobLogIssues: JobLogIssueType[];
    jobLogRootCauses: JobLogRootCauseType[];
    jobLogLocationLofa: JobLogLocationLofaType[];
    showAddEditJobLogModal: boolean;
    mutationLoading: boolean;
    errorMessage?: string;
    onClickCancel: () => void;
    onClickSave: (
        jobLogId: any,
        jobLogTypeId: any,
        jobLogIssueId: any,
        startDate: any,
        endDate: any,
        estimatedDowntime: any,
        jobStageId: any,
        loadId: any,
        notes: any,
        locationLofa: any,
        amount: any,
        rootCauseId: any,
        correctiveAction: any,
    ) => void;
}

const AddEditJobLogModal = ({
    jobId,
    jobLogsData,
    jobLogsTypesData,
    jobLogIssues,
    jobLogRootCauses,
    jobLogLocationLofa,
    showAddEditJobLogModal,
    mutationLoading,
    errorMessage,
    onClickCancel,
    onClickSave,
}: AddEditJobLogModalProps): React.ReactElement => {
    const [logType, setLogType] = useState(jobLogsData ? jobLogsData.jobLogType : '');
    const [logTypeId, setLogTypeId] = useState(jobLogsData ? jobLogsData.jobLogTypeId : null);
    const [issueType, setIssueType] = useState(jobLogsData ? jobLogsData.jobLogIssue : '');
    const [issueTypeId, setIssueTypeId] = useState(jobLogsData ? jobLogsData.jobLogIssueId : null);
    const date = new Date();
    const [startDate, setStartDate] = useState<Date>(
        jobLogsData
            ? jobLogsData.jobLogTypeId === 4
                ? new Date(jobLogsData.startDate?.split(' ')[0] ?? '')
                : new Date(jobLogsData.startDate ?? '')
            : date,
    );
    const [endDate, setEndDate] = useState<Date | undefined>(
        jobLogsData
            ? jobLogsData.jobLogTypeId === 4 || !jobLogsData.endDate
                ? undefined
                : new Date(jobLogsData.endDate)
            : undefined,
    );
    const [downtime, setDowntime] = useState(jobLogsData ? jobLogsData.estimatedDowntime : null);
    const [stage, setStage] = useState(jobLogsData ? jobLogsData.stage : '');
    const [jobStageId, setJobStageId] = useState<string | number | null>(jobLogsData ? jobLogsData.jobStageId : null);
    const [loadId, setLoadId] = useState(jobLogsData ? jobLogsData.loadId : null);
    const [lofa, setLofa] = useState(jobLogsData ? jobLogsData.locationLofa : '');
    const [lofaId, setLofaId] = useState(0);
    const [amount, setAmount] = useState(jobLogsData ? jobLogsData.amount : null);
    const [rootCause, setRootCause] = useState(jobLogsData ? jobLogsData.rootCause : '');
    const [rootCauseId, setRootCauseId] = useState(jobLogsData ? jobLogsData.rootCauseId : null);
    const [notes, setNotes] = useState(jobLogsData ? jobLogsData.notes : '');
    const [correctiveAction, setCorrectiveAction] = useState(jobLogsData ? jobLogsData.correctiveAction : '');

    const [endDateError, setEndDateError] = useState('');
    const [downTimeError, setDownTimeError] = useState('');
    const [loadIdError, setLoadIdError] = useState('');
    const [amountError, setAmountError] = useState('');
    const [notesError, setNotesError] = useState('');

    const logIssueList: JobLogIssueType[] = [];
    jobLogIssues.map(issue => {
        if (issue.jobLogTypeId === logTypeId) {
            logIssueList.push(issue);
        }
    });
    logIssueList.sort((a, b) => {
        let fa = '';
        let fb = '';
        if (a.descrip && b.descrip) {
            fa = a.descrip.toLowerCase();
            fb = b.descrip.toLowerCase();
        }
        if (fa < fb) {
            return -1;
        }
        if (fa > fb) {
            return 1;
        }
        return 0;
    });

    const { loading: stagesForAddLoading, error: stagesForAddError, data: stageDataForAdd } = useQuery<
        GetStagesForJobLog
    >(GET_STAGES_FOR_JOBLOG, {
        variables: {
            jobId: jobId,
            isGrouped: jobLogsData === undefined ? 'true' : 'false',
        },
        fetchPolicy: 'network-only',
    });
    const stagesForAdd: StagesForAddType[] = [];
    if (stageDataForAdd && stageDataForAdd.getStagesForJobLog) {
        stageDataForAdd.getStagesForJobLog.map(stage => {
            if (stage) stagesForAdd.push(stage);
        });
    }

    const { loading: jobLogNotesLoading, error: jobLogNotesError, data: jobLogNotesData } = useQuery<GetJobLogNotes>(
        GET_JOBLOG_NOTES,
        {
            variables: {
                input: {
                    jobLogId: jobLogsData?.id,
                    tzinfo: new Date()
                        .toString()
                        .split('(')[1]
                        .replace(')', ''),
                },
            },
            fetchPolicy: 'network-only',
            skip: jobLogsData ? false : true,
        },
    );
    const jobLogNotes: JobLogNotesType[] = [];
    if (jobLogNotesData && jobLogNotesData.getJobLogNotes) {
        jobLogNotesData.getJobLogNotes.map(jobLogNote => {
            if (jobLogNote) jobLogNotes.push(jobLogNote);
        });
    }

    const onChangeLogType = (logId, logType) => {
        setLogTypeId(logId);
        setLogType(logType);

        if (logTypeId !== logId) {
            setIssueTypeId(null);
            setIssueType('');
        }

        if (logId === 6) {
            setIssueTypeId(-1);
            setIssueType('');
        }
    };

    const onChangeIssue = (issueTypeId, issueType) => {
        setIssueTypeId(issueTypeId);
        setIssueType(issueType);
    };

    const onChangeStartDate = value => {
        const date = new Date(value);
        if (isNaN(date.getTime())) setStartDate(new Date());
        else setStartDate(new Date(value.valueOf()));
    };

    const onChangeEndDate = value => {
        setEndDateError('');
        const date = new Date(value);
        if (isNaN(date.getTime())) setEndDate(undefined);
        else setEndDate(new Date(value.valueOf()));
    };

    const onChangeDowntime = event => {
        setDownTimeError('');
        if (Number.isNaN(event.target.value)) setDowntime(null);
        else setDowntime(parseInt(event.target.value));
    };

    const onChangeStage = (jobStageId, stage) => {
        setStage(stage);
        setJobStageId(jobStageId);
    };

    const onChangeLoadId = event => {
        setLoadIdError('');
        if (Number.isNaN(event.target.value)) setLoadId(null);
        else setLoadId(parseInt(event.target.value));
    };

    const onChangeLofa = (lofaId, lofa) => {
        setLofaId(lofaId);
        setLofa(lofa);
    };

    const onChangeAmount = event => {
        setAmountError('');
        if (Number.isNaN(event.target.value)) setAmount(null);
        else setAmount(parseInt(event.target.value));
    };

    const onChangeRootCause = (rootCauseId, rootCause) => {
        setRootCauseId(rootCauseId);
        setRootCause(rootCause);
    };

    const onChangeCorrectiveAction = event => {
        setCorrectiveAction(event.target.value);
    };

    const onChangeNotes = event => {
        setNotesError('');
        setNotes(event.target.value);
    };

    const handleOnSave = () => {
        let isSaveEnabled = true;

        if (endDate && isNaN(new Date(endDate).getTime())) {
            isSaveEnabled = false;
            setEndDateError('Enter a valid date');
        }

        if (startDate && endDate && new Date(endDate).setSeconds(0) < new Date(startDate).setSeconds(0)) {
            isSaveEnabled = false;
            setEndDateError('End date cannot be less than Start date');
        }

        if (downtime && downtime < 0) {
            isSaveEnabled = false;
            setDownTimeError('Enter a vaild number');
        }

        if (loadId && loadId < 0) {
            isSaveEnabled = false;
            setLoadIdError('Enter a vaild Load Id');
        }

        if (amount && amount < 0) {
            isSaveEnabled = false;
            setAmountError('Enter a vaild Amount');
        }

        if (notes && notes.length > 2000) {
            isSaveEnabled = false;
            setNotesError('Notes cannot be more than 2000 character');
        }

        const isNotesMandatory = logTypeId === 6 || issueType?.toLowerCase() === 'others';
        if (isNotesMandatory && (!notes || !notes.trim())) {
            isSaveEnabled = false;
            setNotesError('Notes are required');
        }

        if (isSaveEnabled) {
            if (jobLogsData) {
                onClickSave(
                    jobLogsData.id,
                    logTypeId,
                    issueTypeId,
                    startDate,
                    endDate,
                    downtime,
                    typeof jobStageId === 'string' ? parseInt(jobStageId) : jobStageId,
                    loadId,
                    notes,
                    lofa,
                    amount,
                    rootCauseId,
                    correctiveAction,
                );
            } else {
                if (!jobStageId) {
                    onClickSave(
                        -1,
                        logTypeId,
                        issueTypeId,
                        startDate,
                        endDate,
                        downtime,
                        jobStageId,
                        loadId,
                        notes,
                        lofa,
                        amount,
                        rootCauseId,
                        correctiveAction,
                    );
                } else {
                    typeof jobStageId === 'string' &&
                        jobStageId.split(',').map((stageId, index) => {
                            onClickSave(
                                -1,
                                logTypeId,
                                issueTypeId,
                                startDate,
                                endDate,
                                downtime,
                                parseInt(stageId),
                                loadId,
                                notes,
                                lofa,
                                amount,
                                rootCauseId,
                                correctiveAction,
                            );
                        });
                }
            }
        }
    };

    return (
        <Modal show={showAddEditJobLogModal} onHide={onClickCancel} dialogClassName="JobLogs-Modal-Container">
            <Modal.Header className="JobLogs-Modal-Header">
                <Modal.Title className="JobLogs-Modal-Header-Container">
                    <button className="material-icons JobLogs-Modal-X-Button" onClick={onClickCancel}>
                        close
                    </button>
                    <div className="JobLogs-Modal-Title">{jobLogsData ? 'Edit Job Log' : 'Add Job Log'}</div>
                </Modal.Title>
            </Modal.Header>

            <div className="JobLogs-Modal-Body">
                {mutationLoading && (
                    <div className="JobLogs-Loading">
                        <Loading />
                    </div>
                )}
                <span className="JobLogs-Modal-Error">{errorMessage}</span>
                <Row className="JobLogs-Modal-Row-Container">
                    <Col md={5}>
                        <label className="Pause-Modal-Label">*Job Log Type</label>
                        <Dropdown className="JobLogs-Modal-Dropdown">
                            <Dropdown.Toggle
                                variant="outline-dark"
                                id="JobLogs-Details-Filter"
                                disabled={jobLogsData ? true : false}
                            >
                                <span>{logType === '' ? 'Job Log Type' : logType}</span>
                            </Dropdown.Toggle>
                            {!jobLogsData && (
                                <Dropdown.Menu>
                                    {jobLogsTypesData.map((jobLogType, index) => {
                                        if (jobLogType.id !== 5)
                                            return (
                                                <Dropdown.Item
                                                    key={index}
                                                    onClick={() => onChangeLogType(jobLogType.id, jobLogType.descrip)}
                                                >
                                                    {jobLogType.descrip}
                                                </Dropdown.Item>
                                            );
                                    })}
                                </Dropdown.Menu>
                            )}
                        </Dropdown>
                    </Col>
                    {logTypeId !== 6 ? (
                        <Col md={5}>
                            <label className="Pause-Modal-Label">*Job Log Issue</label>
                            <Dropdown className="JobLogs-Modal-Dropdown">
                                <Dropdown.Toggle variant="outline-dark" id="JobLogs-Details-Filter">
                                    <span>{issueType === '' ? 'Issue' : issueType}</span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {logIssueList.map((jobLogIssues, index) => (
                                        <Dropdown.Item
                                            key={index}
                                            onClick={() =>
                                                onChangeIssue(jobLogIssues.jobLogIssueId, jobLogIssues.descrip)
                                            }
                                        >
                                            {jobLogIssues.descrip}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </Col>
                    ) : (
                        <></>
                    )}
                </Row>

                {[1, 2, 3, 6].includes(logTypeId ?? 0) ? (
                    <Row className="JobLogs-Modal-Row-Container">
                        <Col md={5}>
                            <DateTimePicker
                                label="*Start date"
                                value={startDate}
                                error={''}
                                onChange={(value: any) => {
                                    onChangeStartDate(value);
                                }}
                            />
                        </Col>
                        <Col md={5}>
                            <DateTimePicker
                                label="End date"
                                value={endDate}
                                error={''}
                                onChange={(value: any) => {
                                    onChangeEndDate(value);
                                }}
                            />
                            <span className="JobLogs-Modal-Error">{endDateError}</span>
                        </Col>
                    </Row>
                ) : (
                    <></>
                )}

                {logTypeId === 4 ? (
                    <Row className="JobLogs-Modal-Row-Container">
                        <Col md={5}>
                            <DateTimePicker
                                dateOnly
                                label="*Date"
                                value={startDate}
                                error={''}
                                onChange={(value: any) => {
                                    onChangeStartDate(value);
                                }}
                            />
                        </Col>
                    </Row>
                ) : (
                    <></>
                )}

                {[1, 2, 3, 6].includes(logTypeId ?? 0) ? (
                    <Row className="JobLogs-Modal-Row-Container">
                        <Col md={5}>
                            <div className="JobLogs-Modal-Input-Container">
                                <label className="JobLogs-Modal-Label">Estimated Downtime (in minutes)</label>
                                <input
                                    type="number"
                                    className="JobLogs-Modal-Input"
                                    onKeyDown={blockInvalidChar}
                                    value={downtime ?? ''}
                                    onChange={event => onChangeDowntime(event)}
                                />
                                <span className="JobLogs-Modal-Error">{downTimeError}</span>
                            </div>
                        </Col>
                        <Col md={5}>
                            <Dropdown className="JobLogs-Modal-Dropdown">
                                <Dropdown.Toggle
                                    variant="outline-dark"
                                    id="JobLogs-Details-Filter"
                                    className="JobLogs-Wellhead"
                                >
                                    <span>{stage === '' ? 'Stage' : stage}</span>
                                </Dropdown.Toggle>
                                {stagesForAddLoading ? (
                                    <Dropdown.Menu>
                                        <div className="JobLogs-Loading">
                                            <Loading />
                                        </div>
                                    </Dropdown.Menu>
                                ) : (
                                    <Dropdown.Menu>
                                        {stagesForAdd.map((stage, index) => (
                                            <Dropdown.Item
                                                key={index}
                                                onClick={() => onChangeStage(stage.stageIds, stage.stageDesc)}
                                            >
                                                {stage.stageDesc}
                                            </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                )}
                            </Dropdown>
                        </Col>
                    </Row>
                ) : (
                    <></>
                )}

                {logTypeId === 4 ? (
                    <>
                        <Row className="JobLogs-Modal-Row-Container">
                            <Col md={5}>
                                <div className="JobLogs-Modal-Input-Container">
                                    <label className="JobLogs-Modal-Label">Load ID</label>
                                    <input
                                        type="number"
                                        className="JobLogs-Modal-Input"
                                        onKeyDown={blockInvalidChar}
                                        value={loadId ?? ''}
                                        onChange={event => onChangeLoadId(event)}
                                    />
                                    <span className="JobLogs-Modal-Error">{loadIdError}</span>
                                </div>
                            </Col>
                            <Col md={5}>
                                <Dropdown className="JobLogs-Modal-Dropdown">
                                    <Dropdown.Toggle variant="outline-dark" id="JobLogs-Details-Filter">
                                        <span>{lofa === '' ? 'Lofa/ Location' : lofa}</span>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => onChangeLofa(null, '')}>None</Dropdown.Item>
                                        {jobLogLocationLofa.map((locationLofa, index) => (
                                            <Dropdown.Item
                                                key={index}
                                                onClick={() => onChangeLofa(locationLofa.id, locationLofa.descrip)}
                                            >
                                                {locationLofa.descrip}
                                            </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Col>
                        </Row>

                        <Row className="JobLogs-Modal-Row-Container">
                            <Col md={5}>
                                <div className="JobLogs-Modal-Input-Container">
                                    <label className="JobLogs-Modal-Label">Amount (in lbs)</label>
                                    <input
                                        type="number"
                                        className="JobLogs-Modal-Input"
                                        onKeyDown={blockInvalidChar}
                                        value={amount ?? ''}
                                        onChange={event => onChangeAmount(event)}
                                    />
                                    <span className="JobLogs-Modal-Error">{amountError}</span>
                                </div>
                            </Col>
                            <Col md={5}>
                                <Dropdown className="JobLogs-Modal-Dropdown">
                                    <Dropdown.Toggle variant="outline-dark" id="JobLogs-Details-Filter">
                                        <span>{rootCause === '' ? 'Root Cause' : rootCause}</span>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => onChangeRootCause(null, '')}>None</Dropdown.Item>
                                        {jobLogRootCauses.map((rootCause, index) => (
                                            <Dropdown.Item
                                                key={index}
                                                onClick={() => onChangeRootCause(rootCause.id, rootCause.descrip)}
                                            >
                                                {rootCause.descrip}
                                            </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Col>
                        </Row>

                        <Row className="JobLogs-Modal-Row-Container">
                            <Col md={10}>
                                <div className="JobLogs-Modal-Input-Container">
                                    <label className="JobLogs-Modal-Label">Corrective Action</label>
                                    <input
                                        type="text"
                                        className="JobLogs-Modal-Input"
                                        value={correctiveAction ?? ''}
                                        onChange={event => onChangeCorrectiveAction(event)}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </>
                ) : (
                    <></>
                )}

                <Row className="JobLogs-Modal-Row-Container">
                    <Col md={10}>
                        <div className="JobLogs-Modal-Input-Container">
                            <label className="JobLogs-Modal-Label">
                                {logTypeId === 6 || issueType?.toLowerCase() === 'others' ? '*Notes' : 'Notes'}
                            </label>
                            <input
                                type="text"
                                className="JobLogs-Modal-Input"
                                value={notes ?? ''}
                                onChange={event => onChangeNotes(event)}
                            />
                            <span className="JobLogs-Modal-Error">{notesError}</span>
                        </div>
                    </Col>
                </Row>

                {jobLogsData && (
                    <Row className="JobLogs-Modal-Row-Container">
                        <Col md={10}>
                            {jobLogNotesLoading ? (
                                <div className="JobLogs-Loading">
                                    <Loading />
                                </div>
                            ) : (
                                <div className="JobLogs-Modal-Input-Container">
                                    <label className="JobLogs-Modal-Label">Notes History</label>
                                    {jobLogNotes.length === 0 ? (
                                        <div className="NoResult-Second-Title-Primary">No notes history found</div>
                                    ) : (
                                        <Table className="tables JobLogs-Modal-Notes-History">
                                            <thead>
                                                <tr>
                                                    <th>Notes</th>
                                                    <th>Updated Date</th>
                                                    <th>Updated By</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {jobLogNotes.map((joblogNote, index) => (
                                                    <tr key={index}>
                                                        <td>{joblogNote.notes}</td>
                                                        <td>{joblogNote.dateCreated}</td>
                                                        <td>{joblogNote.createdBy}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    )}
                                </div>
                            )}
                        </Col>
                    </Row>
                )}
            </div>

            <Modal.Footer className="JobLogs-Modal-Footer">
                <CustomButton title="Cancel" isBordered onClick={onClickCancel} isDisabled={mutationLoading} />
                <CustomButton
                    title="Save"
                    onClick={handleOnSave}
                    isDisabled={
                        !logTypeId ||
                        (logTypeId !== 6 && !issueTypeId) ||
                        !startDate ||
                        mutationLoading ||
                        ((logTypeId === 6 || issueType?.toLowerCase() === 'others') && (!notes || !notes.trim()))
                    }
                />
            </Modal.Footer>
        </Modal>
    );
};

export default AddEditJobLogModal;
